import { ChangeDetectorRef, Component } from '@angular/core';
import { ApiService } from '../services/contratos/contratos.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { format } from 'date-fns';
import { ExtraRequestComponent } from '../app/home/extra-request/extra-request.component';
import { UsuarioLogado } from '../autenticacao/usuario-logado.type';
import { AutenticacaoService } from '../autenticacao/autenticacao.service';
import { NgPluralCase } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'app-cadastro-users',
    templateUrl: './cadastro-users.component.html',
    styleUrls: ['./cadastro-users.component.css'],
    standalone: false
})
export class CadastroUsersComponent {

  item: any = {};
  items: any[] = [];
  usuarios: any[] = [];
  carriers: any[] = [];
  contracts: any[] = [];
  urlAtualiza: string = 'https://uj88w4ga9i.execute-api.sa-east-1.amazonaws.com/dev12';
  urlConsulta: string = 'https://fopq9ohj7e.execute-api.sa-east-1.amazonaws.com/v1';
  urlNotify: string = 'https://29o5gcw81i.execute-api.sa-east-1.amazonaws.com/v1';
  query: string = 'extraFreight';
  queryUsers: string = 'usersPortal';
  queryCarriers: string = 'Carriers';
  queryFlows: string = '';
  comentario: string = "";
  $even: any;
  $odd: any;
  dataSource: any;
  itemsCarrier: any[] = [];
  itemsCompletos: any[] = [];
  searchString: string = '';
  itemsOrigin: any[] | undefined;
  placesOrigin: any[] | undefined;
  usuarioLogado!: UsuarioLogado;
  currentDate = new Date();
  formattedDate = format(this.currentDate, 'ddMMyyyyHHmmss');
  dialogOpen!: boolean;
  formBuilder: any;
  formGroup: any;
  selectedValue = 0;
  contactCarrier: string = '';
  contactTrasport: string = '+5511985507468';
  status: string = 'Requested';
  dataNotify: any;
  isCarrierEnabledCadastro: boolean = false;
  isCarrierEnabled: boolean = false;
  campoTocado: boolean = false;
  senhaAtual!: string;
  isCadastroEnabled: boolean = false;
  idJaExiste: boolean = false;
  editando: boolean = false;
  companys: string[] = ['HBA HUTCHINSON', 'SUSPENSYS/ 61474', 'TUPY (motores)', 'MAXION', 'VOSS', 'EMBALATEC', 'SABÓ', 'PRODUFLEX', 'TUPY', 'AESA', 'NEFAB', 'CCL', 'FUNDIMISA',
    'CONTINENTAL', 'ALLISON', 'POLISTAMPO', 'MART MADEIRAS', 'TCMVW', 'JSLItaquaVW', 'JSLVW', 'TCMSBCVW', 'SESEVW'];

  constructor(
    public dialog: MatDialog,
    private dynamodbService: ApiService,
    private autenticacaoService: AutenticacaoService,
    private http: HttpClient,
    private cdr: ChangeDetectorRef,
    private router: Router,
  ) {
  }

  async ngOnInit(): Promise<void> {
    await this.getUserLogado();
    // await this.enableFieldscadastro();
    await this.enableFields();
    await this.upDate();
  }

  async upDate() {
    await this.getUsers();
    await this.getCarriers();
  }

  onFieldTouched() {
    this.campoTocado = true;
  }

  // enableFieldscadastro() {
  //   if (this.usuarioLogado.role == '9' || this.usuarioLogado.id == null) {
  //     this.isCarrierEnabledCadastro = true;
  //   }
  // }

  enableFields() {
    if (this.usuarioLogado.role == '9') {
      this.isCarrierEnabled = true;
    }
    if (this.usuarioLogado.role == '9' || this.usuarioLogado.id == '') {
      this.isCadastroEnabled = true;
    }
  }

  editDialog(item: any): void {
    // //console.log(this.editando)
    this.campoTocado = false;
    this.enableFields();
    // this.enableFieldscadastro();
    //editDialog2(item: any): void {
    this.item.ID = item.ID;
    this.item.company = item.company;
    this.item.confirmacaoSenha = item.confirmacaoSenha;
    this.item.flowsAccess = item.flowsAccess;
    this.item.nome = item.nome;
    this.item.role = item.role ? item.role : "1";
    this.item.senha = item.senha;
    this.senhaAtual = item.senha;

    this.dialogOpen = true;
  }

  async salvar() {
    // //console.log(this.itemsCompletos)
    // //console.log(this.item.ID)
    // //console.log(this.editando)
    // Verifica se o ID existe em algum objeto do array
    this.idJaExiste = this.itemsCompletos.some(objeto => objeto.ID.toLowerCase() == this.item.ID.toLowerCase());
    if (this.idJaExiste && !this.editando) {
      // //console.log(`O ID ${this.item.ID} já existe em algum objeto.`);
      alert(`O ID ${this.item.ID} já existe.`)
    } else {
      // //console.log(`O ID ${this.item.ID} não existe em nenhum objeto.`);
      if (
        this.item.ID &&
        this.item.senha &&
        this.item.confirmacaoSenha
        // !this.item.includes(this.item.ID)
      ) {
        if (this.item.senha != this.item.confirmacaoSenha) {
          alert("Senhas diferentes")
        } else {
          this.item = {
            "ID": this.item.ID.toLowerCase(),
            "company": this.item.company,
            "confirmacaoSenha": this.item.confirmacaoSenha,
            "flowsAccess": this.item.flowsAccess,
            "nome": this.item.nome,
            "role": this.item.role,
            "senha": this.item.senha
          }
          // //console.log("item para salvar")
          // //console.log(this.item)

          this.item.tableName = this.queryUsers
          // Remover as barras invertidas escapadas
          const itemsDataString = JSON.stringify(this.item); // Acessa a string desejada
          const modifiedString = itemsDataString.replace(/\\"/g, '"'); // Realiza a substituição na string
          // Converter a string JSON para um objeto JavaScript
          const jsonObject = JSON.parse(modifiedString) as { [key: string]: string };
          // Converter o objeto JavaScript de volta para uma string JSON
          const modifiedJsonString = JSON.stringify(jsonObject);
          // //console.log(modifiedJsonString);
          // Converter a string JSON para um objeto JavaScript
          const jsonObject2 = JSON.parse(modifiedJsonString) as { tableName: string, ID: string, acao: string };
          // Criar um array contendo o objeto
          const jsonArray = [jsonObject2];
          await this.dynamodbService.salvar(jsonArray, this.queryUsers, this.urlAtualiza).subscribe(async response => {
            await this.upDate();
            this.dialogOpen = false;
          }, error => {
            console.log(error);
          });
          if (this.senhaAtual != this.item.senha) {
            this.logout();
          }
        }
      } else {
        this.campoTocado = true;
        alert("Formulario incompleto!")
      }
      // this.upDate();
    }
  }

  async logout(): Promise<void> {
    try {
      await this.autenticacaoService.logout()
    } catch (excecao: any) {
      const mensagemErro = excecao?.error?.erro || 'Erro ao realizar o logout!'
      alert(mensagemErro)
    }
  }

  async getCarriers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryCarriers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.carriers = items.map(item => ({ ...item, checked: false }));
              const namesFromObjects = this.carriers.map(obj => obj.name);
              // Concatenar os dois arrays
              this.companys = this.companys.concat(namesFromObjects);
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.carriers')
          // console.log(this.carriers)
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  async getUsers(): Promise<void> {
    const filtroUser = '';
    (await this.dynamodbService.getItems(this.queryUsers, this.urlConsulta, filtroUser)).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          try {
            const items = JSON.parse(response.body);
            if (Array.isArray(items)) {
              this.itemsCompletos = items.map(item => ({ ...item, checked: false }));
              this.usuarios = items.map(item => ({ ...item, checked: false }));
              // //console.log(this.usuarioLogado)
              // //console.log(items)
              if (this.usuarioLogado.role != '9') {
                this.usuarios = items.filter(item => item.ID == this.usuarioLogado.id)
              }
            } else {
              console.error('Invalid items data:', items);
            }
          } catch (error) {
            console.error('Error parsing JSON:', error);
          }
          // //console.log('this.usuarios')
          // //console.log((this.usuarios))
        } else {
          console.error('Invalid response:', response);
        }
      },
      (error: any) => {
        console.error(error);
      }
    );
  }

  cancel(): void {
    this.campoTocado = false;
    this.dialogOpen = false;
  }

  aplicarFiltro() {
    this.items = this.itemsCompletos;
    this.usuarios = this.items.filter(item => this.filtrarItem(item));
  }

  //adicionado filtro para todos os campos
  filtrarItem(item: any): boolean {
    if (!this.searchString) {
      // Se o filtro estiver vazio, retorne verdadeiro para exibir todos os itens
      return true;
    }
    const lowerCaseFilter = this.searchString.toLowerCase();
    for (const prop in item) {
      if (item.hasOwnProperty(prop) && typeof item[prop] === 'string') {
        const lowerCaseProp = item[prop].toLowerCase();
        if (lowerCaseProp.includes(lowerCaseFilter)) {
          return true;
        }
      }
    }
    // Se nenhuma propriedade corresponder ao filtro, retornar falso para não exibir o item
    return false;
  }

  async getUserLogado() {
    // //console.log("logado")
    // //console.log(this.autenticacaoService?.obterUsuarioLogado())
    this.usuarioLogado = await this.autenticacaoService.obterUsuarioLogado()
    // //console.log("user logado")
    // //console.log(this.usuarioLogado)

    if (this.usuarioLogado.id == null) {
      this.editDialog(this.items);
    }
  }

  async deleteItem(ID: string, urlDeleta: string, query: string): Promise<void> {

    const confirmacao = window.confirm("Tem certeza que deseja excluir este usuário?");

    if (confirmacao) {
      await this.dynamodbService.deleteItem(ID, this.urlAtualiza, this.queryUsers).subscribe(
        async response => {
          // setTimeout(() => {
          // this.getItemsFromDynamoDB();
          await this.upDate();
          // }, 400); // Ajuste o tempo de atraso conforme necessário
        },
        error => {
          // Lógica para lidar com erros durante a deleção do item
        }
      );
    }
  }

}